import { observable } from "mobx";
import Model from "@app/state/model/base";

export default class ChatHistory extends Model {
    @observable ai = {
        enabled: undefined,
    };

    @observable articleGalaxy = {
        enabled: undefined,
    };
}
